module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-fullwidth"
  }, [_c('span', {
    staticClass: "title is-3"
  }, [_vm._v(_vm._s(_vm.$route.name))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-257b7fcc","hasScoped":true}!./src/components/title-bar/template.html
// module id = 403
// module chunks = 1